import type { FormInstance } from 'antd';

// After a failed validateFields(), bring the first field in error into view: on a phone the
// Continue button is far below the fields at the top of the step.
export const scrollToFirstError = (form: FormInstance, error: unknown) => {
  const first = (error as { errorFields?: { name: (string | number)[] }[] })?.errorFields?.[0];
  if (first) {
    form.scrollToField(first.name, { block: 'center', behavior: 'smooth' });
  }
};
